import React from 'react';
import FormField from '../FormField';
import SectionHeader from '../SectionHeader';
import { classTypes, branches } from '../../../utils/dwconstants';

const AdmissionDetails = ({ 
  formData, 
  handleChange, 
  handleCourseTypeChange,
  errors, 
  isVisible, 
  toggleSection,
  courseTypes,
  filteredCourses
}) => {
  const learningModeOptions = [
    { value: 'online', label: 'Online' },
    { value: 'offline', label: 'Offline' },
    { value: 'hybrid', label: 'Hybrid' }
  ];
  
  const batchOptions = [
    { value: '9AM-11AM', label: '9AM-11AM' },
    { value: '12PM-2PM', label: '12PM-2PM' },
    { value: '3PM-5PM', label: '3PM-5PM' },
    { value: '6PM-8PM', label: '6PM-8PM' }
  ];

  return (
    <div className="form-section">
      <SectionHeader 
        title="Admission Details" 
        isVisible={isVisible} 
        onClick={toggleSection} 
      />
      
      {isVisible && (
        <div className="section-content">
          <FormField
            label="Course Type"
            type="select"
            name="courseType"
            value={formData.courseType}
            onChange={handleCourseTypeChange}
            options={courseTypes}
          />
          
          <FormField
            label="Course"
            type="select"
            name="course"
            value={formData.course}
            onChange={handleChange}
            options={filteredCourses.map(course => ({
              value: course.courseName,
              label: course.courseName
            }))}
            disabled={!formData.courseType}
          />
          
          <FormField
            label="Class Type"
            type="select"
            name="classType"
            value={formData.classType}
            onChange={handleChange}
            options={classTypes}
          />
          
          <FormField
            label="Learning Mode"
            type="select"
            name="learningMode"
            value={formData.learningMode}
            onChange={handleChange}
            options={learningModeOptions}
            required={true}
          />
          
          <FormField
            label="Batch"
            type="select"
            name="batch"
            value={formData.batch}
            onChange={handleChange}
            options={batchOptions}
            placeholder="Choose Your Batch"
            required={true}
          />
          
          <FormField
            label="Branch"
            type="select"
            name="branch"
            value={formData.branch}
            onChange={handleChange}
            options={branches}
            error={errors.branch}
            required={true}
          />
        </div>
      )}
    </div>
  );
};

export default AdmissionDetails;